module.exports = __webpack_public_path__ + "media/images/logos/logotype-81b7bcb06e9ffe8d20981f9516bea200.svg";